<template>
  <div>
    <div class="settings-card-top"></div>
    <div class="settings-card-body placeholder-body">
      <h3>{{ title }}</h3>
      <p class="settings-subtitle">Esta sección estará disponible próximamente.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettingsPlaceholderSection',
  props: {
    title: {
      type: String,
      default: 'Configuración',
    },
  },
};
</script>
